import { useState, useEffect } from "react";

const MOBILE_WIDTH = 1200;

const useScreenSize = (mobileWidth?: number) => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth < (mobileWidth ?? MOBILE_WIDTH),
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < (mobileWidth ?? MOBILE_WIDTH),
      });
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
};

export default useScreenSize;
